import React, { Component } from "react";
import {
    Center,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Text,
} from '@chakra-ui/react';

export default class DetailDisplay extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

    }


    render() {

        var rowStr = JSON.stringify(this.props.selectedRow, null, '\t')

        return (


            <Modal
                isOpen={this.props.isOpen} 
                onClose={(e)=>this.props.onClose(e)} 
                isCentered
                scrollBehavior="inside"
                size="xl"
            >
                <ModalOverlay />
                <ModalContent >
                    <ModalHeader style={{ fontStyle: "italic", color: "#898787bd" }}>
                        Row Details
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody >
                        <Center>
                            <Text style={{ overflow: "overlay", whiteSpace: "pre-wrap", columns: 1 }}>{rowStr.replace('\{', '').replace('\}', '').replace(new RegExp("\"", "g"), '')}</Text>
                        </Center>
                    </ModalBody>
                    <ModalFooter>

                    </ModalFooter>
                </ModalContent>
            </Modal>
        )

    }
}